// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tour-info-box{display:flex;justify-content:space-between;align-items:flex-start;margin-top:20px}.tour-info-box__info{width:90%}.tour-info-box__info--text{font-size:12px}", ""]);
// Exports
module.exports = exports;
